
import moment from 'moment'
const diffDay = (from, to) => {
    from = moment(from)
    to = moment(to)
    const duration = moment.duration(from.diff(to))
    return duration.as('day')
}

export default diffDay